import { render, staticRenderFns } from "./BottomFooter.vue?vue&type=template&id=54bd11f5&scoped=true&"
import script from "./BottomFooter.vue?vue&type=script&lang=js&"
export * from "./BottomFooter.vue?vue&type=script&lang=js&"
import style0 from "./BottomFooter.vue?vue&type=style&index=0&id=54bd11f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bd11f5",
  null
  
)

export default component.exports